import { Button } from '#/components/Button/Button';
import { Tooltip } from '#/components/Tooltip/Tooltip';
import { useI18n } from '#/i18n/hooks/useI18n';
import { useCurrentSavedSearch } from '#/modules/search/hooks/useCurrentSavedSearch';
import {
  useRecentlySavedSearchId,
  useSavedSearchesActions,
} from '#/modules/userDashboard/contexts/SavedSearchesContext';
import { userDashboardSavedItemsRoute } from '#/modules/userDashboard/routing/userDashboard.routes';
import { trackClicked } from '#/utils/analytics/track/trackClicked';
import { useModal } from '#/zustand-stores/modalStore';

import { SaveSearchButtonHolder } from './SaveSearchButton.styled';
import { SaveSearchButtonTooltip } from './SaveSearchButtonTooltip';

type Props = {
  saveSearch: () => Promise<void>;
};

export function SaveSearchButton({ saveSearch }: Props) {
  const { i18n } = useI18n();

  const { savedSearch } = useCurrentSavedSearch();
  const { dismissRecentlySavedSearch } = useSavedSearchesActions();
  const { recentlySavedSearchId } = useRecentlySavedSearchId();

  const { modal } = useModal();

  if (savedSearch) {
    return (
      <SaveSearchButtonHolder data-qa-id="save-search">
        <Tooltip
          content={
            <SaveSearchButtonTooltip
              savedSearch={savedSearch}
              onSavedOrDismissed={() => {
                dismissRecentlySavedSearch();
              }}
            />
          }
          size="large"
          placement="bottom-left"
          tooltipWidth="270px"
          renderCondition={savedSearch.id === recentlySavedSearchId && !modal}
          variant="brand-green"
          withArrow={false}
          closeable
          onClose={() => {
            dismissRecentlySavedSearch();
          }}
        >
          <Button
            type="link"
            icon={{ name: 'bookmark', type: 'normalized' }}
            variant="secondary"
            href={userDashboardSavedItemsRoute.with({ tab: 'SEARCH' })}
            qaId="save-search"
          >
            {i18n('My Saved Searches')}
          </Button>
        </Tooltip>
      </SaveSearchButtonHolder>
    );
  }

  return (
    <Button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        trackClicked('Get Email Alerts');
        void saveSearch();
      }}
      icon={{ name: 'bookmark', type: 'normalized' }}
      variant="secondary"
      qaId="save-search"
    >
      {i18n('Save Search')}
    </Button>
  );
}
